export default function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/size.js
// module id = 413
// module chunks = 0 1 2 3 4